import { IIntakeModel, IntakeModel, IntakePetModel } from "@common/models";
import { IntakeService } from '@common/services';
import { find } from "lodash";
import { DateTime } from "luxon";
import { action, computed, flow, makeObservable, observable } from "mobx";

export class IntakeStore {
    @observable intakePublicId: string = '';
    @observable linkSource: string = 'email';
    @observable intake: IntakeModel = new IntakeModel();
    @observable isReadOnly: boolean = false;
    @observable loading: boolean = true;
    @observable selectedIntakePetId: number = 0;
    @observable selectedIntakePetIndex: number = -1;

    constructor() {
        makeObservable<IntakeStore>(this, undefined, {
            autoBind: true
        });
    }

    @computed get selectedPet(): IntakePetModel | undefined {
        if (this.selectedIntakePetId == 0) return undefined;
        return find(this.intake.pets, (pet) => {
            return pet.intakePetId == this.selectedIntakePetId;
        });
    }

    //#region Actions

    @action.bound setParamValues(intakePublidId: string, linkSource?: string, intakepetid?: number) {
        this.intakePublicId = intakePublidId;
        if (linkSource)
            this.linkSource = linkSource;

        if (intakepetid)
            this.selectedIntakePetId = intakepetid;
    }

    @action.bound intakeIsReadOnly(): boolean {
        const today = DateTime.now();

        if (!this.intake.expectedFullVisitDate)
            return true;

        const visitDate = DateTime.fromJSDate(this.intake.expectedFullVisitDate);
        const visitDateAlreadyHappened = today.startOf("day") > visitDate;

        if (visitDate && visitDateAlreadyHappened && this.linkSource === 'petpass')
            return true;

        return false;
    }

    //#endregion

    //#region Flows

    getIntake = flow(function* (this: IntakeStore) {
        this.intake = yield IntakeService.getIntake(this.intakePublicId, { showError: true });

        this.isReadOnly = this.intake.isReadOnly || this.intake.isClinicCancelled || this.intakeIsReadOnly()

        // Track the opening of the intake
        if (this.intake) {
            yield IntakeService.openIntake(this.intake.intakeId, this.linkSource, { showError: true });
        }
    });

    updateIntake = flow(function* (this: IntakeStore, intake: IIntakeModel) {
        return yield IntakeService.updateIntake(intake, this.linkSource, { showError: true });
    });

    //#endregion
}
